module.exports = __webpack_public_path__ + "static/img/64-1.e94b9fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/64-1.jpg
// module id = si1Q
// module chunks = 0